import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { STATE__generation } from '../STATE__generation';

export function try_remove_user_task_from_load_generations_set(state: STATE__generation, user_task: DTO__user_task) {
  if (!user_task.are_generations_loaded) return;
  if (!state.user_task_load_generations_in_progress.has(user_task._id)) return;

  state.user_task_load_generations_in_progress.delete(user_task._id);

  //need to force rerender
  state.user_task_load_generations_in_progress = new Set(state.user_task_load_generations_in_progress);
}
